import compact from "lodash/compact";

export default function parseTagParams(tags: string | null | undefined) {
  // Keys/values cannot contain commas, enabling splitting by comma for parsing tags.
  // Update this logic if commas are allowed in the future.
  const tagArray = tags ? tags.split(",").map((tag) => tag.trim()) : [];
  return new Tags(tagArray);
}

class Tags {
  tags: string[];

  constructor(tags: string[]) {
    this.tags = tags;
  }

  excluding(tag: string): Tags {
    if (!tag) {
      return this;
    }

    let newTags = this.tags.filter((parsedTag) => parsedTag !== tag);
    // Remove any empty strings
    newTags = compact(newTags);

    return new Tags(newTags);
  }

  including(tag: string): Tags {
    if (!tag) {
      return this;
    }

    // Use a Set to ensure that we don't add duplicate tags
    let newTags = Array.from(new Set([...this.tags, ...[tag]]));
    // Remove any empty strings
    newTags = compact(newTags);

    return new Tags(newTags);
  }

  hasTag(tag: string): boolean {
    return this.tags.includes(tag);
  }
}
